import { StoreState } from '../types';

export const isAlertOpened = (store: StoreState) => store.globalAlert.isOpened;
export const getAlertMessage = (store: StoreState): string => store.globalAlert.message;
